import conversionReducer from './conversion.slice'

export default conversionReducer
